
export enum InvoiceEvalOperCd {
	EQUAL_TO = 'EqualTo',
	GREATER_THAN = 'GreaterThan',
	IN = 'In',
	LESS_THAN = 'LessThan',
	NOT_EQUAL_TO = 'NotEqualTo'}

